// extracted by mini-css-extract-plugin
export default {"segmentedControl":"ViewSwitch-module__segmentedControl--SK6vU","active":"ViewSwitch-module__active--N1jWU"};